import { useTracking } from "./TrackingContext";

export function useTrackingFunctions() {
  const { trackEvent } = useTracking();

  const trackContact = (reason, courseName) => {
    trackEvent("contact_request_submit", {
      reason,
      course_name: courseName,
      activated: 1,
    });
  };

  const trackRatgeberStart = (url, courseName) => {
    trackEvent("guide_download_start", {
      url,
      course_name: courseName,
      activated: 1,
    });
  };

  const trackRatgeberAbgeschlossen = (url, courseName) => {
    trackEvent("guide_download_submit", {
      url,
      course_name: courseName,
      activated: 1,
    });
  };

  const trackRelatedRatgeberClick = (url, courseName) => {
    trackEvent("guide_related_click", {
      url,
      course_name: courseName,
      activated: 1,
    });
  };

  const trackBewertungStart = (url) => {
    trackEvent("valuation_start", {
      url,
      activated: 1,
    });
  };

  const trackBewertungAbgeschlossen = (url) => {
    trackEvent("valuation_submit", {
      url,
      activated: 1,
    });
  };

  const trackSuchprofilStart = () => {
    trackEvent("search_profile_start", {
      activated: 1,
    });
  };

  const trackSuchprofilAbgeschlossen = () => {
    trackEvent("search_profile_submit", {
      activated: 1,
    });
  };

  const trackBeratungsterminStart = (url) => {
    trackEvent("appointment_request_start", {
      url,
      activated: 1,
    });
  };

  const trackBeratungsterminClick = (url, reason) => {
    trackEvent("appointment_type_select", {
      url,
      reason,
      activated: 1,
    });
  };

  const trackBeratungsterminAbgeschlossen = (url) => {
    trackEvent("appointment_request_submit", {
      url,
      activated: 1,
    });
  };

  const trackExposeAnfrageStart = (url, reason) => {
    trackEvent("expose_request_start", {
      url,
      reason,
      activated: 1,
    });
  };

  const trackExposeAnfrageAbgeschlossen = (url) => {
    trackEvent("expose_request_submit", {
      url,
      activated: 1,
    });
  };

  const trackRelatedExposeClick = (url) => {
    trackEvent("expose_related_click", {
      url,
      activated: 1,
    });
  };

  return {
    trackContact,
    trackRatgeberStart,
    trackRatgeberAbgeschlossen,
    trackRelatedRatgeberClick,
    trackBewertungStart,
    trackBewertungAbgeschlossen,
    trackSuchprofilStart,
    trackSuchprofilAbgeschlossen,
    trackBeratungsterminStart,
    trackBeratungsterminClick,
    trackBeratungsterminAbgeschlossen,
    trackExposeAnfrageStart,
    trackExposeAnfrageAbgeschlossen,
    trackRelatedExposeClick,
  };
}
